import React from 'react';
import moment from 'moment';
import { MONTH_DAY_FORMAT, HOUR_FORMAT } from 'app/utils/types';
import { Layout, Flex } from 'app/components/base/Layout';
import Icon from 'app/components/base/Icon';
import Lightbox from 'mz-ui-kit/core/Lightbox';
import DateSelectScreen from './DateSelectScreen';
import { getTicketInfo } from 'app/components/search-results/TimeTableSelect/utils/getTripScheduleProps';
import ChangeScheduleScreen from 'app/components/search-results/Trip/Mobile/ChangeScheduleScreen';
import builder from '../builder';

import style from './style.css';
import posthog from 'posthog-js';

/**
 * Mobile component for showing selected date and time in pickup block.
 * On click to the block it will show date/time picker subpage.
 * @return {Component}
 */
export class MobilePickupDateTime extends React.Component {
  state = {
    dateSelectorOpened: false,
    timeSelectorOpened: false,
  };

  render() {
    const { value, ticketValidityMessage, timeProps } = this.props;
    const dateValue = moment(value);
    const dateStr = !timeProps
      ? `${dateValue.format(MONTH_DAY_FORMAT)} -`
      : dateValue.format(MONTH_DAY_FORMAT);
    const timeStr = dateValue.format(HOUR_FORMAT);

    console.log({ props: this.props });

    return (
      <>
        <Lightbox
          showed={this.state.dateSelectorOpened}
          onClose={() => this.setState({ dateSelectorOpened: false })}
          render={() => (
            <DateSelectScreen
              minDate={this.props.minDate}
              fieldName={this.props.fieldName}
              notime={!!this.props.timeProps}
              handleDateSelected={(e) => {
                const initial_value_date = moment(e).format('DD/MM/YYYY');
                const end_value_date = moment(this.props.value).format(
                  'DD/MM/YYYY'
                );
                const diff_value_date =
                  moment(e).diff(moment(this.props.value), 'days') +
                  ' day' +
                  (moment(e).diff(moment(this.props.value), 'days') > 1
                    ? 's'
                    : '');

                const posthogPayloadDate = {
                  initial_value_date,
                  end_value_date,
                  diff_value_date,
                };

                const initial_value_time = moment(e).format('HH:mm');
                const end_value_time = moment(this.props.value).format('HH:mm');
                const diff_value_time =
                  Math.ceil(
                    moment(e).diff(moment(this.props.value), 'minutes') / 60
                  ) +
                  ' hour' +
                  (Math.ceil(
                    moment(e).diff(moment(this.props.value), 'minutes') / 60
                  ) > 1
                    ? 's'
                    : '');

                const posthogPayloadTime = {
                  initial_value_time,
                  end_value_time,
                  diff_value_time,
                };

                posthog.capture('Date Selected', posthogPayloadDate);
                posthog.capture('Time Selected', posthogPayloadTime);

                this.setState({ dateSelectorOpened: false });
              }}
            />
          )}
        />
        <Layout direction="column" nowrap className={style.container}>
          <Layout
            className={style.field}
            direction="row"
            align="start center"
            onClick={() => {
              this.setState({ dateSelectorOpened: true });
            }}
            nowrap
          >
            <Flex className={style.text} size="grow">
              {dateStr} &nbsp;
              {!timeProps && timeStr}
            </Flex>
            <Icon name="keyboard_arrow_right" />
          </Layout>
          {timeProps && (
            <>
              <Layout
                className={style.field}
                direction="row"
                align="start center"
                onClick={() => {
                  this.setState({ timeSelectorOpened: true });
                }}
                nowrap
              >
                <Flex className={style.text} size="grow">
                  <span>
                    {getTicketInfo(
                      timeProps.trip,
                      timeProps.selectedTicket
                    ).departureDatetime.format(HOUR_FORMAT)}
                  </span>
                  {!!ticketValidityMessage && (
                    <div className={style.ticketValidity}>
                      {ticketValidityMessage}
                    </div>
                  )}
                </Flex>
                <Icon name="keyboard_arrow_right" />
              </Layout>
              <Lightbox
                showed={this.state.timeSelectorOpened}
                onClose={() => this.setState({ timeSelectorOpened: false })}
                render={() => (
                  <ChangeScheduleScreen
                    trip={this.props.timeProps.trip}
                    selectedTicket={this.props.timeProps.selectedTicket}
                    isReturn={this.props.timeProps.isReturn}
                    onConfirm={({ departureTicket, updatedTrip }) => {
                      const actionParamName = this.props.timeProps.isReturn
                        ? 'returnTicket'
                        : 'departureTicket';
                      this.props.timeProps.scheduleDepartureTime({
                        [actionParamName]: departureTicket,
                        updatedTrip,
                        bookTripForm: true,
                      });
                    }}
                    onClose={() => this.setState({ timeSelectorOpened: false })}
                  />
                )}
              />
            </>
          )}
        </Layout>
      </>
    );
  }
}

// TODO: move to Flow types
// MobilePickupDateTime.propTypes = {
//   value: PropTypes.object,
//   subpages: PropTypes.object.isRequired,
//   timeProps: PropTypes.object.isRequired,
//   minDate: PropTypes.object,
//   fieldName: PropTypes.string,
//   ticketValidityMessage: PropTypes.node
// };

export default builder(MobilePickupDateTime);
